module.exports = __webpack_public_path__ + "img/9788952229373.84c23c42.jpg";